export const actionTypes = {
  REQUEST_START: 'MESSAGES.LIST.REQUEST_START',
  REQUEST_START_SKIP_LOADING: 'MESSAGES.LIST.REQUEST_START.SKIP_LOADING',
  REQUEST_SUCCESS: 'MESSAGES.LIST.REQUEST_SUCCESS',
  REQUEST_FAILURE: 'MESSAGES.LIST.REQUEST_FAILURE',
  FEEDBACK_SENT: 'MESSAGES.LIST.FEEDBACK_SENT',
};

export function startRequest() {
  return {
    type: actionTypes.REQUEST_START,
  };
}

export function startRequestSkipLoading() {
  return {
    type: actionTypes.REQUEST_START_SKIP_LOADING,
  };
}

export function requestSuccess(data) {
  return {
    type: actionTypes.REQUEST_SUCCESS,
    payload: data,
  };
}

export function requestFailure(error) {
  return {
    type: actionTypes.REQUEST_FAILURE,
    payload: error,
  };
}

export function feedbackSent(id) {
  return {
    type: actionTypes.FEEDBACK_SENT,
    payload: id,
  };
}
